/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PresignPackageImageResponse interface.
 */
export function instanceOfPresignPackageImageResponse(value) {
    return true;
}
export function PresignPackageImageResponseFromJSON(json) {
    return PresignPackageImageResponseFromJSONTyped(json, false);
}
export function PresignPackageImageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'uploadUrl': json['uploadUrl'] == null ? undefined : json['uploadUrl'],
        'storageKey': json['storageKey'] == null ? undefined : json['storageKey'],
    };
}
export function PresignPackageImageResponseToJSON(json) {
    return PresignPackageImageResponseToJSONTyped(json, false);
}
export function PresignPackageImageResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'uploadUrl': value['uploadUrl'],
        'storageKey': value['storageKey'],
    };
}
